import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ColumnKey, getEditorColumns } from "@faire/retailer-visitor-shared/features/PointOfSale/components/BulkEditor/BulkEditorColumns";
import { POSLogoWithText } from "@faire/retailer-visitor-shared/features/PointOfSale/components/POSLogo";
import { SurveyModal } from "@faire/retailer-visitor-shared/features/PointOfSale/components/SurveyModal";
import { CLOVER, POS_ARTICLE_ID } from "@faire/retailer-visitor-shared/features/PointOfSale/consts";
import { useEnabledPOSTypes } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/useEnabledPOSTypes";
import { useModalState } from "@faire/retailer-visitor-shared/hooks/useModalState";
import { Section } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/Section";
import { useFAQFieldLabels } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/useFAQFieldLabels";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { MediumFormatting } from "@faire/web--source/common/localization/formatting";
import { Accordion } from "@faire/web--source/slate/Accordion";
import { Button } from "@faire/web--source/slate/Button";
import { Column, HorizontalLine, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import article from "@faire/web-api--source/routes/support/articles/articleId";
import React from "react";
import styled from "styled-components";
export var FAQSectionV2 = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isMobile = useViewport().isMobile;
    var _useModalState = useModalState(), isSurveyModalOpen = _useModalState.isOpen, openSurveyModal = _useModalState.openModal, closeSurveyModal = _useModalState.closeModal;
    var sectionHeader = strictLocalize({
        id: "Wii95s",
        defaultMessage: [
            {
                type: 0,
                value: "FAQs"
            }
        ]
    });
    if (isMobile) {
        // Create section header above accordion to provide consistent padding with other sections
        return /*#__PURE__*/ _jsxs(Section, {
            color: Core.text.inverse,
            mobilePadding: "0",
            children: [
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                }),
                /*#__PURE__*/ _jsx(SectionHeaderPadding, {
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "displaySSerifRegular",
                        children: sectionHeader
                    })
                }),
                /*#__PURE__*/ _jsx(Accordion, {
                    title: "",
                    items: getFAQEntries(openSurveyModal)
                }),
                /*#__PURE__*/ _jsx(HelpCenterLink, {}),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "7x"
                }),
                isSurveyModalOpen ? /*#__PURE__*/ _jsx(SurveyModal, {
                    onClose: closeSurveyModal
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Section, {
        color: Core.text.inverse,
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "9x"
            }),
            /*#__PURE__*/ _jsx(Accordion, {
                title: sectionHeader,
                items: getFAQEntries(openSurveyModal)
            }),
            /*#__PURE__*/ _jsx(HelpCenterLink, {}),
            /*#__PURE__*/ _jsx(HorizontalLine, {}),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "9x"
            }),
            isSurveyModalOpen ? /*#__PURE__*/ _jsx(SurveyModal, {
                onClose: closeSurveyModal
            }) : null
        ]
    });
};
var HelpCenterLink = function() {
    return /*#__PURE__*/ _jsx(ArticleLinkPadding, {
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "subheadingSansRegular",
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "pVsuuT",
                defaultMessage: [
                    {
                        type: 0,
                        value: "For more information about our POS integration, visit our "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Help center"
                            }
                        ]
                    }
                ],
                values: {
                    LinkFormatting: HelpCenterLinkFormatting
                }
            })
        })
    });
};
var HelpCenterLinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: article(POS_ARTICLE_ID),
        target: "_blank",
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "subheadingSansRegular",
            children: chunks
        })
    });
};
var getFAQEntries = function(openSurveyModal) {
    return [
        {
            question: /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "/D5Evx",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "What product information will be synced between Faire and my POS?"
                        }
                    ]
                })
            }),
            answer: /*#__PURE__*/ _jsx(SyncedInfoAnswer, {})
        },
        {
            question: /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "9LKRnW",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "How will my orders be imported to my POS?"
                        }
                    ]
                })
            }),
            answer: /*#__PURE__*/ _jsxs(ListWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "iPTVqx",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "You can control how your orders are imported to your POS by configuring your settings when setting up the integration. You can always change this later."
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("ul", {
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "XPsWNy",
                                        defaultMessage: [
                                            {
                                                type: 8,
                                                value: "MediumFormatting",
                                                children: [
                                                    {
                                                        type: 0,
                                                        value: "Manually add products to your POS:"
                                                    }
                                                ]
                                            },
                                            {
                                                type: 0,
                                                value: " Choose which products you want to add or link to your POS. Bulk edit and configure product information before you sync to your POS."
                                            }
                                        ],
                                        values: {
                                            MediumFormatting: MediumFormatting
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "nfSVJb",
                                        defaultMessage: [
                                            {
                                                type: 8,
                                                value: "MediumFormatting",
                                                children: [
                                                    {
                                                        type: 0,
                                                        value: "Automatically add products to your POS:"
                                                    }
                                                ]
                                            },
                                            {
                                                type: 0,
                                                value: " Faire will add products to your POS upon purchase. Edit product information on Faire or your POS after products sync."
                                            }
                                        ],
                                        values: {
                                            MediumFormatting: MediumFormatting
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        },
        {
            question: /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "0leVc/",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "What if I already have products in my POS? Will Faire link them for me?"
                        }
                    ]
                })
            }),
            answer: /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "2CuXQt",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Faire will find existing products with matching SKUs for you to link. If your products don't have SKUs, you can search your existing products by their names and link them. Once products are linked, product information will be synced between Faire and your POS."
                        }
                    ]
                })
            })
        },
        {
            question: /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "JshQVM",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Will Faire update my inventory counts for me?"
                        }
                    ]
                })
            }),
            answer: /*#__PURE__*/ _jsxs(ListWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "Cka272",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "You can control this by adjusting your settings."
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("ul", {
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "5MaiJn",
                                        defaultMessage: [
                                            {
                                                type: 8,
                                                value: "MediumFormatting",
                                                children: [
                                                    {
                                                        type: 0,
                                                        value: "Manually update inventory count:"
                                                    }
                                                ]
                                            },
                                            {
                                                type: 0,
                                                value: " You\u2019ll need to update inventory count in your POS. Recommended if you manage inventory in other ways, like purchase orders."
                                            }
                                        ],
                                        values: {
                                            MediumFormatting: MediumFormatting
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "kvSzEf",
                                        defaultMessage: [
                                            {
                                                type: 8,
                                                value: "MediumFormatting",
                                                children: [
                                                    {
                                                        type: 0,
                                                        value: "Automatically update inventory count:"
                                                    }
                                                ]
                                            },
                                            {
                                                type: 0,
                                                value: " Faire will update inventory count in your POS when orders are delivered."
                                            }
                                        ],
                                        values: {
                                            MediumFormatting: MediumFormatting
                                        }
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        },
        {
            question: /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "x11gtP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "What if my store has multiple locations?"
                        }
                    ]
                })
            }),
            answer: /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "XLx3a0",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "We now support syncing of product information across multiple locations for our Shopify and Square integrations. Inventory count updates are only supported for a single, selected location at this time."
                        }
                    ]
                })
            })
        },
        {
            question: /*#__PURE__*/ _jsx(Typography, {
                variant: "subheadingSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "LqVThi",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "What if I use a different POS system?"
                        }
                    ]
                })
            }),
            answer: /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "UmWhsV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Shopify, Square, and Clover are the most popular POS systems among Faire\u2019s retailers. If you use a different POS system, "
                        },
                        {
                            type: 8,
                            value: "LinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "let us know"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ". Your input will help us make our integration available for more retailers."
                        }
                    ],
                    values: {
                        LinkFormatting: SurveyButton(openSurveyModal)
                    }
                })
            })
        }
    ];
};
var SyncedInfoAnswer = function() {
    var isMobile = useViewport().isMobile;
    var _useEnabledPOSTypes = useEnabledPOSTypes(), enabledTypes = _useEnabledPOSTypes.types;
    if (isMobile) {
        return /*#__PURE__*/ _jsxs(Column, {
            gap: "3x",
            children: [
                /*#__PURE__*/ _jsx(SyncedInfoAnswerHeader, {}),
                enabledTypes.map(function(type) {
                    return /*#__PURE__*/ _jsx(POSSupportedFields, {
                        posType: type
                    }, type);
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Column, {
        gap: "3x",
        children: [
            /*#__PURE__*/ _jsx(SyncedInfoAnswerHeader, {}),
            /*#__PURE__*/ _jsx(Row, {
                gap: "6x",
                children: enabledTypes.map(function(type) {
                    return /*#__PURE__*/ _jsx(POSSupportedFields, {
                        posType: type
                    }, type);
                })
            })
        ]
    });
};
var SyncedInfoAnswerHeader = function() {
    return /*#__PURE__*/ _jsx(Typography, {
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "BHXobt",
            defaultMessage: [
                {
                    type: 0,
                    value: "The following information is synced between Faire and your POS. You can edit the information before adding it to your POS using our bulk editor."
                }
            ]
        })
    });
};
var POSSupportedFields = function(param) {
    var posType = param.posType;
    var getLabel = useFAQFieldLabels();
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(POSLogoWithText, {
                type: posType
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            getColumnKeysByPosType(posType).map(function(key) {
                return /*#__PURE__*/ _jsx(Typography, {
                    children: getLabel(key, posType)
                }, key);
            })
        ]
    });
};
var getColumnKeysByPosType = function(posType) {
    var columns = getEditorColumns(posType);
    var keysToExclude = getKeysToExcludeByPosType(posType);
    var keys = [];
    columns.forEach(function(column) {
        if (keysToExclude.includes(column.key)) {
            return;
        }
        keys.push(column.key);
        if (column.subColumns) {
            var subKeys = column.subColumns.map(function(subColumn) {
                return subColumn.key;
            });
            keys = _to_consumable_array(keys).concat(_to_consumable_array(subKeys));
        }
    });
    return keys;
};
// List of keys that should be excluded from the FAQ section based on the POS type
var getKeysToExcludeByPosType = function(posType) {
    switch(posType){
        case CLOVER:
            return [
                ColumnKey.IMAGE
            ];
        default:
            return [];
    }
};
var SurveyButton = function(onClick) {
    return function SurveyButton(chunks) {
        return /*#__PURE__*/ _jsx(Button, {
            variant: "tertiary",
            onClick: onClick,
            children: chunks
        });
    };
};
var SectionHeaderPadding = styled.div.withConfig({
    componentId: "sc-4b83513d-0"
})([
    "padding:",
    ";"
], getSpacing(0, "2x"));
var ArticleLinkPadding = styled.div.withConfig({
    componentId: "sc-4b83513d-1"
})([
    "padding:",
    ";"
], getSpacing("2x", "3x"));
var ListWrapper = styled.div.withConfig({
    componentId: "sc-4b83513d-2"
})([
    "li{margin-left:",
    ";padding-top:",
    ";list-style:initial;}"
], getSpacing("3x"), getSpacing("1x"));
